import {makeCamerasItems, makeCamerasTableItems} from "../helpers/cameras-items.js";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import { useState} from "react";

export default function Cameras({ title, data }) {
    const camItems = makeCamerasItems(data);
    const camTable = makeCamerasTableItems(data);

    return (
        <div className="space-y-4 px-5">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                {title}
            </h2>
            <InfoGrid title="" items={camItems} columns={3} className="px-0!" />
            <InfoGrid title="" items={camTable} columns={3} className="px-0!" />
        </div>
    )
}